/**
 * Datos de mercado de un producto (GET /api/product-insights/market/:id), compartidos
 * por los widgets de mercado de la ficha: el primero que se monta pide, los demás usan
 * lo mismo, y «Volver a buscar» en cualquiera los actualiza a todos. El back busca en
 * la web una sola vez por producto; acá solo se evita pedirlo varias veces.
 */
import Vue from "vue";
import { wencesApi } from "@/api/wencesApi";

const state = Vue.observable({ byId: {} });
const inflight = {};

export function marketState(itemId) {
  return state.byId[itemId] || null;
}

export function loadMarket(itemId, lang, force = false) {
  if (!itemId) return Promise.resolve();
  const current = state.byId[itemId];
  if (!force && (inflight[itemId] || (current && current.data))) return inflight[itemId] || Promise.resolve();
  Vue.set(state.byId, itemId, { data: current ? current.data : null, loading: true, failed: false });
  const url = `/api/product-insights/market/${itemId}`;
  const req = force
    ? wencesApi.post(`${url}/refresh`, null, { params: { lang } })
    : wencesApi.get(url, { params: { lang, _: Date.now() } });
  inflight[itemId] = req
    .then(({ data }) => {
      const d = (data && data.data) || {};
      Vue.set(state.byId, itemId, { data: d, loading: false, failed: d.status === "error" });
    })
    .catch(() => {
      Vue.set(state.byId, itemId, { data: current ? current.data : null, loading: false, failed: true });
    })
    .finally(() => {
      delete inflight[itemId];
    });
  return inflight[itemId];
}
